export default __webpack_public_path__ + "static/media/AnswerBar.fb608518.jpg";